module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$root.$data.cart) ? _c('div', [_c('div', {
    staticClass: "px2 mb3"
  }, [_c('md-button', {
    staticClass: "md-raised right",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Tilbake")]), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Fullfør bestilling")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Last opp filer og se over detaljene nedenfor før du fullfører bestillingen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "px2 mb3"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Last opp filer")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Last opp trykklare filer for produktene du skal bestille.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Om du ønsker å bestille flere varianter av et produkt (f.eks. beachflagg med to forskjellige motiver) kan du legge til flere filer på produktet.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Trykkfiler for produkter:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.state.is('working')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.$root.$data.cart.items), function(cartItem, index) {
    return _c('tbody', [_c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p3 border-bottom border-light-grey"
    }, [_c('div', {
      staticClass: "fz24 light mb1"
    }, [_vm._v(_vm._s(cartItem.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(cartItem.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey center"
    }, [_vm._v("\n                    " + _vm._s(cartItem.quantity) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-blue",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.pickFile(cartItem.id, 'cart_item')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Last opp ny trykkfil")]), _vm._v(" "), _c('md-icon', [_vm._v("file_upload")])], 1), _vm._v(" "), _c('div', {
      staticClass: "hiddenfile"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": 'file_cart_item_' + cartItem.id
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, cartItem.id, 'cart_item')
        }
      }
    })])], 1)]), _vm._v(" "), _vm._l((cartItem.attachments), function(attachment, attIndex) {
      return _c('tr', [_c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey",
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "bold mb1"
      }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": attachment.artworks[0].href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
      }, [_c('md-button', {
        staticClass: "md-icon-button text-grey",
        attrs: {
          "type": "file"
        },
        nativeOn: {
          "click": function($event) {
            _vm.deleteAttachment(index, attachment.id, 'cart_items')
          }
        }
      }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
    })], 2)
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Andre filer:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.state.is('working')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.$root.$data.cart.attachments), function(attachment, attIndex) {
    return _c('tr', [_c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
    }, [_c('div', {
      staticClass: "bold mb1"
    }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": attachment.artworks[0].href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-grey",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.deleteAttachment(attIndex, attachment.id, 'cart')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.pickFile(_vm.$root.$data.cart.id, 'cart')
      }
    }
  }, [_vm._v("\n                      Last opp ny fil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "hiddenfile"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": 'file_cart_' + _vm.$root.$data.cart.id
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.$root.$data.cart.id, 'cart')
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
  })])], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Merknader til bestilling")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("\n            Fyll inn eventuelle merknader du har til bestillingen.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('md-input-container', [_c('label', [_vm._v("Merknader")]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Levering")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("\n            Velg leveringsadresse for bestillingen.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "clearfix mxn3"
  }, [_c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "fz18 mb3"
  }, [_vm._v("Velg")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "delivery"
    }
  }, [_vm._v("Velg leveringsadresse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "delivery",
      "id": "delivery"
    },
    model: {
      value: (_vm.deliveryAddress),
      callback: function($$v) {
        _vm.deliveryAddress = $$v
      },
      expression: "deliveryAddress"
    }
  }, [_c('md-subheader', [_vm._v("Standard leveringsadresse")]), _vm._v(" "), (_vm.user && _vm.user.store.post_address) ? _c('md-option', {
    attrs: {
      "value": -1
    }
  }, [_vm._v(_vm._s(_vm.user.store.post_address.name) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('md-subheader', [_vm._v("Alle leveringsadresser")]), _vm._v(" "), _vm._l((_vm.addresses), function(address, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": index
      }
    }, [_vm._v("\n                      " + _vm._s(address.address.name) + "\n                    ")])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "fz18 mb3"
  }, [_vm._v("Valgt leveringsadresse:")]), _vm._v(" "), (_vm.user && _vm.user.store.post_address) ? _c('div', {
    staticClass: "bg-light-blue p3 rounded"
  }, [_c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.name))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.address))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Postnummer")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.zip))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Poststed")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.city))])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Detaljer")]), _vm._v(" "), _c('div', {
    staticClass: "mb3"
  }, [_vm._v("\n            Fyll ut detaljene for bestillingen. Informasjonen blir kun brukt som intern referanse.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Bestilling")]), _vm._v(" "), _c('p', [_vm._v("\n              Gi bestillingen et navn. F.eks. \"Banner og beachflag til Firma AS\".\n            ")]), _vm._v(" "), _c('div', [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('title')
    }
  }, [_c('label', [_vm._v("Navn på bestilling")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), (_vm.errors.hasError('title')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('title')))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Kundeopplysninger")]), _vm._v(" "), _c('p', [_vm._v("\n              Fyll inn detaljene til kunden du bestiller for.\n            ")]), _vm._v(" "), _c('div', [_c('md-input-container', [_c('label', [_vm._v("Navn/firma")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.data.client.name),
      callback: function($$v) {
        _vm.$set(_vm.data.client, "name", $$v)
      },
      expression: "data.client.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Telefon/mobil")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.data.client.phone),
      callback: function($$v) {
        _vm.$set(_vm.data.client, "phone", $$v)
      },
      expression: "data.client.phone"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("E-post")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.data.client.email),
      callback: function($$v) {
        _vm.$set(_vm.data.client, "email", $$v)
      },
      expression: "data.client.email"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light mb3"
  }, [_vm._v("Fullfør")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Oppsummering")]), _vm._v(" "), _c('p', {
    staticClass: "mt2"
  }, [_vm._v("\n              Se over besillingen før du fullfører:\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.$root.$data.cart.items), function(cartItem, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "cell-image p2"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(cartItem.product),
        "width": "80",
        "height": "80"
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz18 mb1"
    }, [_vm._v(_vm._s(cartItem.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(cartItem.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "center px3"
    }, [_vm._v("\n                  " + _vm._s(cartItem.quantity) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-grey truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.unit_price / 100)) + ",-")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.total / 100)) + ",-")])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-top border-light-grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey pt3 truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.vat_total / 100)) + ",-\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("MVA")])]), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey pt3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.gross_total / 100)) + ",-\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total")])])])], 2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.errors.hasErrors()) ? _c('div', {
    staticClass: "error-box p3 rounded sh1 mb3"
  }, [_c('div', {
    staticClass: "fz18 mb1"
  }, [_vm._v("Feil i felter")]), _vm._v(" "), _c('div', [_vm._v("Vennligst se over besillingen og prøv på nytt. Fant følgende feil i bestilling:")]), _vm._v(" "), _c('ul', {
    staticClass: "m0 mt2"
  }, _vm._l((_vm.errors.errors), function(error) {
    return _c('li', {
      staticClass: "fz16"
    }, [_vm._v(_vm._s(error[0]))])
  }))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-success m0 px3 py1 mt2",
    attrs: {
      "disabled": _vm.state.is('ordering')
    },
    nativeOn: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [(_vm.state.is('ordering')) ? _c('span', [_vm._v("Plasserer din besilling...")]) : _c('span', [_vm._v("Fullfør og plasser bestilling")])])], 1)])])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Fil")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey "
  }), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Pris pr. stk.")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Betingelser")]), _vm._v(" "), _c('p', {
    staticClass: "mt2"
  }, [_vm._v("\n              Leveringstid er normalt 10-14 arbeidsdager. Alle bestillinger vil bli belastet med frakt og hånderingsgebyr\n              på 600 kr for mindre ordre (under 90x120x10 cm) og 1 200 kr for større ordre.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc7ecaa8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/Checkout.vue
// module id = 650
// module chunks = 1